import React, { useState, useEffect, useContext, useRef } from "react";
import "./contactDetails.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/successImg.png";
import { Formik, useFormik } from "formik";
import { object, string } from "yup";
import * as Yup from "yup";
// import Preloader from "../../Components/Preloader/Preloader";
import Preloader from "../../Components/Loader/Loader";
import { axiosInstance } from "../../axiosInstance";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
const ContactSchema = object({
  contact_number: string()
    .matches(/^\d{10}$/, "Contact Number must be 10 digits")
    .required("this feild is required"),
  state: string().required("this feild is required"),
  city: string().required("this feild is required"),
  address: string().required("this feild is required"),
  is_accepted: Yup.bool().oneOf([true], "this feild is required"),
});

export function ContactDetails() {
  const { language } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [stateId, setStateId] = useState();
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const navigate = useNavigate();

  const contactNumberRef = useRef(null);
  const addressL1Ref = useRef(null);

  const formik = useFormik({
    initialValues: {
      contact_number: "",
      // address_l1: "",
      // address_l2: "",
      state: "",
      city: "",
      address: "",
      is_accepted: false,
      is_blur: true,
      is_public: true,
      is_web: true,
    },
    validationSchema: ContactSchema,
    onSubmit: async (values, { resetForm }) => {
      // Before API call, check validation errors manually to scroll
      if (Object.keys(formik.errors).length > 0) {
        // Scroll to first error field
        if (formik.errors.contact_number) {
          contactNumberRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          contactNumberRef.current?.focus();
        } else if (formik.errors.state) {
          addressL1Ref.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          addressL1Ref.current?.focus();
        }
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const personalDetails = JSON.parse(
          localStorage.getItem("personalDetails") || "{}"
        );
        const familyDetails = JSON.parse(
          localStorage.getItem("familyDetails") || "{}"
        );

        // ✅ Check if images exist
        if (
          !Array.isArray(personalDetails.profile) ||
          personalDetails.profile.length === 0
        ) {
          alert("Please upload at least one image before submitting.");
          return; // ❌ Exit early without making API call
        }

        const formData = new FormData();

        // ✅ Convert base64 to file and append
        if (Array.isArray(personalDetails.profile)) {
          for (let i = 0; i < personalDetails.profile.length; i++) {
            const base64Str = personalDetails.profile[i];
            if (base64Str?.startsWith("data:")) {
              const [meta, base64] = base64Str.split(",");
              const mime = meta.match(/:(.*?);/)?.[1] || "image/jpeg";
              const binary = atob(base64);
              const array = new Uint8Array(binary.length);
              for (let j = 0; j < binary.length; j++) {
                array[j] = binary.charCodeAt(j);
              }
              const blob = new Blob([array], { type: mime });
              const file = new File(
                [blob],
                `profile_${i}.${mime.split("/")[1]}`,
                { type: mime }
              );
              formData.append("profile", file); // ✅ appending binary file
            }
          }
        }

        // ✅ Append all other values
        Object.entries({ ...personalDetails, ...familyDetails }).forEach(
          ([key, value]) => {
            if (key !== "profile") {
              formData.append(key, value);
            }
          }
        );

        const selectedState = state.find((s) => s.id === Number(values.state));
        const selectedCity = city.find((c) => c.id === Number(values.city));
        // ✅ Append contact form values
        formData.append("contact_number", values.contact_number);
        formData.append("state", selectedState?.name || "");
        formData.append("city", selectedCity?.name || "");
        formData.append("address", values.address);
        formData.append("is_accepted", values.is_accepted ? "true" : "false");
        formData.append("is_blur", values.is_blur ? "true" : "false");
        formData.append("is_public", values.is_public ? "true" : "false");
        formData.append("is_web", values.is_web ? "true" : "false");

        // ✅ Debug FormData
        for (const pair of formData.entries()) {
          console.log(`${pair[0]}:`, pair[1]);
        }

        // ✅ Axios POST
        const response = await axiosInstance.post("biodata", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.status === true) {
          setLoading(false);
          localStorage.removeItem("personalDetails");
          localStorage.removeItem("familyDetails");

          resetForm();
          handleOpen();

          setTimeout(() => {
            navigate("/view-more");
          }, 2000); // wait 2000 ms = 2 seconds
        } else {
          toast.error(response.data.message);
        }

        // } catch (error) {
        //   console.error("Submission error:", error);
        //   alert("Submission failed. Check console for details.");
      } catch (error) {
        console.error("Submission error:", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
          console.error("Response status:", error.response.status);
          console.error("Response headers:", error.response.headers);
          const message = error.response.data?.message || "Submission failed.";
          toast.error(message);
          alert(`Error 400: ${JSON.stringify(error.response.data, null, 2)}`);
        } else if (error.request) {
          console.error(
            "Request made but no response received:",
            error.request
          );
          toast.error("No response from server.");
        } else {
          console.error("Error setting up request:", error.message);
          toast.error("Something went wrong.");
        }
      } finally {
        setLoading(false); // Stop loader no matter what
      }
    },
  });

  async function LoadState() {
    try {
      const response = await axios.get(
        "https://devapi.naticharami.in/api/v1/dropdown/states"
        // "https://api.naticharami.in/api/v1/dropdown/states"
      );
      const data = response.data;
      console.log("State", response.data);
      setState(data);
    } catch (error) {
      console.log("Error white fetching");
      toast.error("Error white fetching", error);
    }
  }
  async function LoadCity(stateId) {
    try {
      const response = await axios.get(
        `https://devapi.naticharami.in/api/v1/dropdown/cities/${stateId}`
        // `https://api.naticharami.in/api/v1/dropdown/cities/${stateId}`
      );
      const data = response.data;
      console.log("State", response.data);
      setCity(data);
    } catch (error) {
      console.log("Error white fetching");
      toast.error("Error white fetching", error);
    }
  }
  useEffect(() => {
    if (stateId) {
      LoadCity(stateId);
    }
  }, [stateId]);

  useEffect(() => {
    LoadState();
  }, []);
  return (
    <>
      {loading && <Preloader />}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
          // Scroll to first error on submit if validation fails
          if (Object.keys(formik.errors).length > 0) {
            if (formik.errors.contact_number) {
              contactNumberRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              contactNumberRef.current?.focus();
            } else if (formik.errors.address_l1) {
              addressL1Ref.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              addressL1Ref.current?.focus();
            }
          }
        }}
      >
        <div>
          {/* row1 */}
          <div className="contact-subcontainer">
            <div>
              <div className="contact-label">
                {translations[language].contact_number}{" "}
                <span className="text-danger">*</span>
              </div>
              <div className="contact-input">
                <input
                  type="text"
                  placeholder="Enter your number"
                  id="contact_number"
                  name="contact_number"
                  onChange={formik.handleChange}
                  ref={contactNumberRef}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.contact_number &&
                    formik.errors.contact_number
                      ? "error"
                      : ""
                  }
                />
                <div>
                  {formik.touched.contact_number &&
                    formik.errors.contact_number && (
                      <div className="text-danger">
                        {formik.errors.contact_number}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div>
              <div className="contact-label">
                {translations[language].state}{" "}
                <span className="text-danger">*</span>
              </div>
              <div className="contact-input">
                <select
                  name="state"
                  id="state"
                  value={formik.values.state}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    formik.setFieldValue("state", selectedId);
                    setStateId(selectedId);
                    console.log("Selected State ID:", selectedId);
                  }}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.state && formik.errors.state ? "error" : ""
                  }`}
                >
                  <option value="" disabled>
                    Select State
                  </option>
                  {state?.map((list) => (
                    <option value={list.id} key={list.id}>
                      {list.name}
                    </option>
                  ))}
                </select>
                <div>
                  {formik.touched.state && formik.errors.state && (
                    <div className="text-danger">{formik.errors.state}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* row2 */}
          <div className="contact-subcontainer">
            <div>
              <div className="contact-label">
                {translations[language].city}{" "}
                <span className="text-danger">*</span>
              </div>

              <div>
                <select
                  name="city"
                  id="city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.city && formik.errors.city ? "error" : ""
                  }`}
                >
                  <option value="" disabled>
                    Select City
                  </option>
                  {city?.map((list) => (
                    <option value={list.id} key={list.id}>
                      {list.name}
                    </option>
                  ))}
                </select>
                <div className="contact-label" style={{ marginTop: "0px" }}>
                  First select the state
                </div>
                {formik.touched.city && formik.errors.city && (
                  <div className="text-danger">{formik.errors.city}</div>
                )}
              </div>
            </div>
            <div>
              <div className="contact-label">
                {translations[language].address}{" "}
                <span className="text-danger">*</span>
              </div>
              <div className="contact-input">
                <input
                  type="text"
                  placeholder="Enter address"
                  id="address"
                  onChange={formik.handleChange}
                  className={
                    formik.touched.contact_number &&
                    formik.errors.contact_number
                      ? "error"
                      : ""
                  }
                />
                {formik.touched.address && formik.errors.address && (
                  <div className="text-danger">{formik.errors.address}</div>
                )}
              </div>
            </div>
          </div>
          {/* row3 */}
          <div className="contact-subcontainer mt-3">
            <div>
              <div className="checkboxLabel">
                {" "}
                1. I accept to share my uploaded images publicly for matchmaking
                purposes.
              </div>
              <div
                style={{ marginTop: "10px", marginBottom: "20px" }}
                className="form-check form-switch "
              >
                <input
                  type="checkbox"
                  id="is_public"
                  name="is_public"
                  className="form-check-input"
                  checked={formik.values.is_public}
                  onChange={formik.handleChange}
                />
                &nbsp;
                <span
                  style={{
                    color: "#2B171B",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  {formik.values.is_public ? "Yes" : "No"}
                </span>
                {formik.errors.is_public && formik.touched.is_public && (
                  <div className="text-danger">{formik.errors.is_public}</div>
                )}
              </div>
            </div>
          </div>
          {/* row 4 */}
          <div className="contact-subcontainer">
            <div>
              <div className="checkboxLabel">
                {" "}
                2. I accept to share my uploaded images on Nathicharami platform
              </div>
              <div
                style={{ marginTop: "10px", marginBottom: "20px" }}
                className="form-check form-switch "
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="is_web"
                  name="is_web"
                  checked={formik.values.is_web}
                  onChange={formik.handleChange}
                />
                <span
                  style={{
                    color: "#2B171B",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  {formik.values.is_web ? "Yes" : "No"}
                </span>

                {formik.errors.is_web && formik.touched.is_web && (
                  <div className="text-danger">{formik.errors.is_web}</div>
                )}
              </div>
            </div>
          </div>
          {/* row 5 */}
          <div className="contact-subcontainer">
            <div>
              <div className="checkboxLabel"> 3. Blur Image in Website</div>
              <div
                style={{ marginTop: "10px", marginBottom: "20px" }}
                className="form-check form-switch "
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="is_blur"
                  name="is_blur"
                  checked={formik.values.is_blur}
                  onChange={formik.handleChange}
                />
                <span
                  style={{
                    color: "#2B171B",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  {formik.values.is_blur ? "Yes" : "No"}
                </span>

                {formik.errors.is_blur && formik.touched.is_blur && (
                  <div className="text-danger">{formik.errors.is_blur}</div>
                )}
              </div>
            </div>
          </div>
          {/* row 6 */}
          <div className="contact-subcontainer">
            <div style={{ marginTop: "20px" }}>
              <input
                type="checkbox"
                id="is_accepted"
                name="is_accepted"
                checked={formik.values.is_accepted}
                onChange={formik.handleChange}
              />
              &nbsp;
              <span className="checkboxLabel">
                By clicking on checkbox, you agree to the Terms & Conditions
              </span>
              {formik.errors.is_accepted && formik.touched.is_accepted && (
                <div className="text-danger">{formik.errors.is_accepted}</div>
              )}
            </div>
          </div>
          {/* modal */}
          <div>
            <div className="btnBasicSave">
              <Button type="submit">{translations[language].btnSubmit}</Button>
            </div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose} //close modal on background click
              closeAfterTransition
            >
              <Fade in={open}>
                <Box sx={style} className="modal-box">
                  <img srcSet={successImg} />
                  <Typography
                    id="transition-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Thank You
                  </Typography>
                  <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                    The profile has been successfully updated
                  </Typography>
                </Box>
              </Fade>
            </Modal>
          </div>
        </div>
      </form>
    </>
  );
}
